var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResourcesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3807 6.45225L13.3807 3.26025C12.6207 2.91325 11.3787 2.91325 10.6207 3.26025L3.62266 6.45225C2.79766 6.82725 2.79766 7.44125 3.62266 7.81625L10.5597 10.9802C11.3517 11.3402 12.6547 11.3402 13.4467 10.9802L20.3837 7.81625C21.2047 7.44125 21.2047 6.82625 20.3797 6.45225H20.3807Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49963 14.4624L3.62363 16.2024C2.79863 16.5774 2.79863 17.1914 3.62363 17.5664L10.5606 20.7304C11.3526 21.0904 12.6556 21.0904 13.4476 20.7304L20.3846 17.5664C21.2096 17.1914 21.2096 16.5764 20.3846 16.2024L16.6376 14.3984",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49975 9.58594L3.61875 11.3279C2.79375 11.7029 2.79375 12.3169 3.61875 12.6919L10.5557 15.8549C11.3477 16.2159 12.6507 16.2159 13.4427 15.8549L20.3797 12.6919C21.2097 12.3169 21.2098 11.7019 20.3848 11.3279L16.4998 9.58594",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourcesIcon);
export default __webpack_public_path__ + "static/media/ResourcesIcon.6b4f41c118d2b02056698b1276244f74.svg";
export { ForwardRef as ReactComponent };